import React, { Component } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { fetchInitialData3, fetchInitialData2} from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import withContext from "../../../withContext";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import './growthtracker.css';
import Nonloggedin from './common/Nonloggedin.js';
import ChildListOverlay from './common/ChildListOverlay';
import PastMeasurement from './common/PastMeasurement';
import AddGrowthDetails from './common/AddGrowthDetails';
import GrowthDetailsChart from './common/GrowthDetailsChart';
import AskqueOverlay from './common/AskqueOverlay';
import FaqPopup from './common/FaqPopup';
import FaqPopupGrowth from './common/FaqPopupGrowth';
import DisclaimerPopup from './common/DisclaimerPopup';
import FeedbackPopup from './common/FeedbackPopup';
import Swiper from "react-id-swiper";
import * as actions from "./Actions.js";
import FAQPopupGrowth from "./common/FaqPopupGrowth";

const service = new Service();

class GrowthTracker extends Component {
  constructor(props) {
    super(props);
    let initialData = {};
    let isLoggedin = false;
    let authData = '';
    let childdata=[];
    let vaccinationSummary=[];
    let pastMeasurement=[];
    let minValues=[];
    let maxValues=[];
    let userPhoto='';
    let banner_img_mob='';
    let banner_img_desk='';
    this.dateRef = React.createRef();
    let isApp = "";
    const isDesktop = __isBrowser__
        ? window.innerWidth >= 768
        : global.isdesktop;

    this.wrapperRef = React.createRef();
    this.adRef = React.createRef();

    if (global.ftk == '') {
        isLoggedin = false
    } else {
        isLoggedin = true
    }
     if (!isLoggedin && typeof document !== "undefined") {
        const cookieData = document.cookie || "";
        const cookieAry = cookieData.split(";");

        for (let i = 0; i < cookieAry.length; i++) {
            const cookie = cookieAry[i].trim();

            if (cookie.startsWith("app_ftk=")) {
                const appFtk = cookie.substring("app_ftk=".length).trim();

                if (appFtk !== "") {
                    isLoggedin = true;
                }

                break;
            }
        }
    }

    if (__isBrowser__ && window.__initialData__ && window.__initialData__["initialData"] ) {
        initialData = window.__initialData__["initialData"];

        authData = global?.userAry;

        // console.log('------------authData1--',authData);
        // console.log('---------------global.ftk', global.ftk);
        userPhoto = authData?.childData?.UserMaster?.userPhoto;

        if(authData){
             const filteredChildList = authData?.childData?.UserChildList?.filter(
                child => !child.IsExpected
            );

            const validChildIds = filteredChildList?.map(child => child.ChildId);

            const filteredVaccinationSummary = initialData?.data1?.vaccinationSummary?.filter(
                item => validChildIds?.includes(item.childId)
            );

            childdata = filteredChildList;
            vaccinationSummary = filteredVaccinationSummary;
            pastMeasurement = initialData?.data2?.result.recent_measurement_new;
            minValues = initialData?.data2?.result.minimum_values;
            maxValues = initialData?.data2?.result.maximum_values;
        }


            banner_img_mob = initialData?.data3?.result?.find(item => item.type === 'growth')?.mob_banner_img;

            banner_img_desk = initialData?.data3?.result?.find(item => item.type === 'growth')?.desk_banner_img;

        delete window.__initialData__;
    } else {
      
    }
        if (this.props.location.search.includes('from=app')) {
            isApp = true;
        }

        this.state = {
            vaccinationSummary: vaccinationSummary || [],
            isLoggedin: isLoggedin,
            childlist: childdata,
            selectedChild: childdata[0],
            selectedChildGrowthDetails: vaccinationSummary[0]?.growthdetails,
            activeTab:'wt',
            pastMeasurement: pastMeasurement,
            minValues:minValues||[],
            maxValues:maxValues||[],
            actualWeight: [],
            isDesktop: isDesktop,
            selectedChildId: childdata[0]?.ChildId,
            feedbacktext:'',
            feedbackError:'',
            gotoFirstpage: false,
            userPhoto: userPhoto,
            isApp:isApp,
            articles_growth:[],
            // selectedChild:'',
            adState: "normal",
            banner_img_mob: banner_img_mob,
            banner_img_desk: banner_img_desk,
            uploadedImageUrl:'',
            activeBannerIndex: 0,

            bannerList: [
                    {
                        desk: 'https://cdn.cdnparenting.com/brainbees/community/vaccination/growth_tracker_with_add_banner.jpg',
                        mob: 'https://cdn.cdnparenting.com/brainbees/community/vaccination/growth_tracker_with_add_banner.jpg'
                    },
                    {
                        desk: "https://cdn.cdnparenting.com/brainbees/community/vaccination/banner2.png",
                        mob: "https://cdn.cdnparenting.com/brainbees/community/vaccination/banner2.png"
                    },
                    {
                        desk: "https://cdn.cdnparenting.com/brainbees/community/vaccination/banner3.png",
                        mob: "https://cdn.cdnparenting.com/brainbees/community/vaccination/banner3.png"
                    }
                ]
        }

    
  }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {

        let filteredChildList = childData?.UserChildList?.filter(
            child => !child.IsExpected
        );

        const childinfo = ftk
            ? (filteredChildList || []).map(child => ({
                childid: child.ChildId,
                dob: child.DOB,
                childgender: child.Gender?.toLowerCase() === "boy" ? "0" : "1",
                }))
            : [];
       

        var LatestFtk = "";
        if (cookieData && cookieData.includes("app_ftk")) {
            var cookieAry = cookieData.split(";");
            for (var i = 0; i < cookieAry.length; i++) {
            if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                LatestFtk = cookieAry[i].split("app_ftk=")[1];
            }
            }
        }
        var header = {
            "Content-Type": "application/json",
            ftk: ftk != "" ? ftk : LatestFtk,
            uid: uId,
            "access-token": authData["access-token"],
            "user-agent": global.userAgent,
            isdesktop: global.isdesktop,
        };
            
        let obj1 = {
            url: global.api_url + "vaccinationSummary",
            body: JSON.stringify({
                summaryfilterType: 0,
                childinfo
            })
        };

        let obj2 = {
            url: global.api_url + "getchartgrowthdetails",
            body: JSON.stringify({
                chid: childinfo?.[0]?.childid || "0",
                gender: childinfo?.[0]?.childgender || "0",
                dob: childinfo?.[0]?.dob || "0"
            })
        };

        let obj3 = {
            url: global.api_url + "getBanners",
            body: JSON.stringify({
            })
        }

        // return fetchInitialData2(obj1, obj2, JSON.stringify(header));
        return fetchInitialData3(obj1, obj2, obj3, JSON.stringify(header));

    }

    componentDidMount() {

        let fcAuthCookie = document.cookie
    .split('; ')
    .find(cookie => cookie.startsWith('FC_AUTH='));

  let fcAuthValue = fcAuthCookie
    ? decodeURIComponent(fcAuthCookie.split('=')[1])
    : '';

    if (!fcAuthValue) {
          let allCookies = document.cookie;
          let appFtkCookie = allCookies.split('; ').find(cookie => cookie.startsWith('app_ftk='));
          fcAuthValue = appFtkCookie ? appFtkCookie.split('=')[1] : null;
        }
        
        console.log("Final auth token value (FC_AUTH or app_ftk):", fcAuthValue);
       
        if (!fcAuthValue || fcAuthValue === 'undefined' || fcAuthValue === '') {
            this.setState({ isLoggedin: false });
        }

        console.log('childlist.length >>>>>>>', this.state.childlist.length);
        console.log('isLoggedin >>>>>>>', this.state.isLoggedin);
        console.log('global.ftk >>>>>>>', global.ftk);
        // console.log('app_ftk >>>>>>>', app_ftk);

        // console.log('-----------selectedChildGrowthDetails', this.state.selectedChildGrowthDetails);

        this.updateDeviceType();
        window.addEventListener('resize', this.updateDeviceType);
        
        this.ticking = false;
        document.addEventListener("scroll", this.onScroll, true);
        
        if ( Array.isArray(this.state.childlist) && this.state.childlist.length > 0 ) {

            if (!this.state.selectedChildGrowthDetails?.wt) {
                this.openAddGrowthDetails();
            }

            if(!this.state.isApp){
                console.log('-------------------desktop Growth');
                window.adpushup = window.adpushup || {};
                window.adpushup.que = window.adpushup.que || [];

                window.adpushup.que.push(function () {
                    if (window.adpushup.triggerAd) {
                        window.adpushup.triggerAd("c21ba44c-f89a-460f-bbb9-bc29c66647af");
                        window.adpushup.triggerAd("1f428a2d-000a-439a-8305-6d9c86cf257a");
                    }
                });

            }
           
            let childdob = this.state.selectedChild?.DOB;
            let ageInMonths = getAgeInMonths(childdob);

            function getAgeInMonths(dob) {
                if (!dob) return 0;

                const birthDate = new Date(dob);
                const today = new Date();

                let months =
                    (today.getFullYear() - birthDate.getFullYear()) * 12 +
                    (today.getMonth() - birthDate.getMonth());

                if (today.getDate() < birthDate.getDate()) {
                    months--;
                }

                return Math.max(months, 0);
            }
            
            let postdata = {
                "age":ageInMonths
            }

            let url = global.api_ci_url + "api/fetchfromCI/getGrowthContent"; 

            service.postServiceCall(url, postdata)
            .then((json) => {
                if (json.msg === 1 && json.result?.articles) {
                    this.setState({
                        articles_growth: json.result.articles
                    });
                }
            })
            .catch((error) => {
                console.error("Error toggling like:", error);
                service.hideLoader();
            });


           

        }


        window.onFileUpload = (response) => {
            console.log("inside function >>>>>>>.");
            try {
                const fileData = JSON.parse(response); // Parse the JSON string from the app

                if (fileData.PermStatus === "allow" && fileData.FilePath) {
                // Update your React component's state with the received image URL
                if (window.setUploadedImage) {
                    window.setUploadedImage(fileData.FilePath);
                }
                } else {
                console.error(
                    "File upload not allowed or invalid data received:",
                    fileData
                );
                }
            } catch (error) {
                console.error("Error parsing onFileUpload response:", error);
            }
        };


        window.setUploadedImage = (filePath) => {
            console.log("Uploaded FilePath:", filePath);

            try {

                const cleanPath = decodeURIComponent(filePath).replace(/["']+$/, "");

                // Get only filename
                const fileName = cleanPath.substring(
                    cleanPath.lastIndexOf("/") + 1
                );

                console.log("File Name:", fileName);



                const fileEle = document
                    .getElementsByClassName("askQuest-overlay")[0]
                    .getElementsByClassName("uploaded-files-list")[0];

                const imageElement = fileEle.getElementsByClassName("cmt-image")[0];
                const fileNameElement = imageElement.getElementsByClassName("added-file-name")[0];

                // Show image upload section
                imageElement.style.display = "flex";

                // Put returned filepath in the UI
                fileNameElement.textContent = fileName;

                this.setState({ uploadedImageUrl: filePath });


            } catch (error) {
                console.error("Error updating uploaded image:", error);
            }
        };

        const adElement = document.getElementById(
            "938aa2bb-9021-42d7-8f3e-bb08b29fa0a6"
        );

        if (adElement) {
            adElement.style.margin = "0";
        }


        // this.bannerInterval = setInterval(() => {
        //     if (this.state.bannerList.length > 1) {
        //         this.setState(prevState => ({
        //             activeBannerIndex:
        //                 prevState.activeBannerIndex ===
        //                 prevState.bannerList.length - 1
        //                     ? 0
        //                     : prevState.activeBannerIndex + 1
        //         }));
        //     }
        // }, 4000);


        if(this.state.isApp){

            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            const isAndroid = /Android/i.test(userAgent);
            const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

            

            actions.loadCallbackFile();
            const appMXPJson = {
                appurl: [
                    {
                        pagetype: "handleappdailog",
                        display: '0'
                        
                    }
                ]
            };
            service.jsontracker(JSON.stringify(appMXPJson));
            
        }

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDeviceType);
        // window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("scroll", this.onScroll);
        delete window.setUploadedImage;
        // clearInterval(this.bannerInterval);
    }

    updateDeviceType = () => {
        const isDesktop = window.innerWidth >= 768;
        if (this.state.isDesktop !== isDesktop) {
            this.setState({ isDesktop });
        }
    }


    handleScroll = () => {
        const wrapper = this.wrapperRef.current;
        const ad = this.adRef.current;

        if (!wrapper || !ad) return;

        const topOffset = 50;

        const wrapperRect = wrapper.getBoundingClientRect();
        const wrapperTop = wrapperRect.top + window.pageYOffset;
        const wrapperBottom = wrapperTop + wrapper.offsetHeight;

        const adHeight = ad.offsetHeight;
        const scrollTop = window.pageYOffset;

        let newState = "normal";

        const buffer = 5;

        if (scrollTop >= wrapperTop - topOffset) {
            if (scrollTop + topOffset + adHeight >= wrapperBottom - buffer) {
                newState = "bottom";
            } else {
                newState = "fixed_add";
            }
        }

        // Update only if changed
        if (newState !== this.state.adState) {
            this.setState({ adState: newState });
        }
    };

    onScroll = () => {
        if (this.ticking) return;

        this.ticking = true;

        requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
        });
    };


    // toLogin=()=>{

    //     if(this.state.isApp){
    //         actions.loadCallbackFile();
    //         const eventName = "add_your_child_detail_click";
    //         const eventData = {
    //             'page_type':'growth',
    //             sendWithoutGtm: "yes" //mixpanel event send without GTM
    //         };
    //         service.createfinalTrackingObject(eventName, eventData);
    //     }

    //     if(!global.ftk){
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //     }else{
    //         const url = `/my-account/myprofile?growthtracker`;
    //         // window.open(service.getRedirectUrl(url), 'noopener,noreferrer');
    //         window.location.href = service.getRedirectUrl(url);
    //     }
       
    // }

    toLogin = () => {


        // NON-LOGIN USER
        if (!this.state.isLoggedin) {
            console.log('!this.state.isLoggedin <<<<<<')
            // APP → Native login callback
            if (this.state.isApp) {

                const appMXPJson = {
                    appurl: [
                        {
                            pagetype: "login",
                            url: "https://www.firstcry.com/m/login?from=app"
                            // redirecturl: global.currentURL
                        }
                    ]
                };

                service.jsontracker(JSON.stringify(appMXPJson));
                return;
            }

            // MS / DS → Existing web login flow
            service.showAlert("Please Login");

            window.location.href =
                global.loginUrl + "?URL=" + global.currentURL;

            return;
        }else{
            if (this.state.isApp) {
                const appMXPJson = {
                    appurl: [
                        {
                            pagetype: "child",
                        },
                    ],
                };
                service.jsontracker(JSON.stringify(appMXPJson));
                return;
            }
        }

        if (this.state.isApp) {
            actions.loadCallbackFile();

            const eventName = "add_your_child_detail_click";
            const eventData = {
                page_type: "growth",
                sendWithoutGtm: "yes"
            };

            service.createfinalTrackingObject(eventName, eventData);
        }

        // LOGGED-IN USER
        const url = "/my-account/myprofile?growthtracker";

        window.location.href = service.getRedirectUrl(url);
    };


    openprofilePopup=() =>{
        if(global.ftk != ""){
            document.querySelector(".select_child_popup").style.display="block";

            if(!this.state.isDesktop){
                document.querySelector("body").style.overflow = "hidden";
            }
        }
    }

    getLatestChildData =(data)=>{

        console.log('------------data', data);

        if(this.state.isApp){

            actions.loadCallbackFile();
            const eventName = "child_selected";
            const eventData = {
                'child_name':data.ChildName,
                'page_type':'growth',
                'child_gender':data.Gender,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

        this.setState({selectedChildId: data.ChildId})

        const childinfo = {
            childid: data.ChildId,
            dob: data.DOB,
            childgender: data.Gender?.toLowerCase() == "boy" ? "0" : "1",
        };

        let postdata = {
            summaryfilterType: 0,
            childinfo: [childinfo]
        }

        let url = global.api_ci_url + "api/fetchfromCI/vaccinationSummary"; 
        
        service.postServiceCall(url, postdata)
        .then((json) => {
            // console.log('-----------json', json);
            if(json.msg == 1){
                document.querySelector("body").style.overflow = "unset";
                const latestGrowthDetails = json?.vaccinationSummary?.[0]?.growthdetails || {};

                this.setState(
                    {
                        selectedChild: data,
                        selectedChildGrowthDetails: latestGrowthDetails,
                        activeTab: "wt"
                    },
                    () => {
                        // Runs after state update is complete
                        if (
                            !latestGrowthDetails ||
                            Object.keys(latestGrowthDetails).length === 0
                        ) {
                            this.openAddGrowthDetails();
                        }

                            let childdob = this.state.selectedChild?.DOB;

                            let ageInMonths = getAgeInMonths(childdob);

                            function getAgeInMonths(dob) {
                                if (!dob) return 0;

                                const birthDate = new Date(dob);
                                const today = new Date();

                                let months =
                                    (today.getFullYear() - birthDate.getFullYear()) * 12 +
                                    (today.getMonth() - birthDate.getMonth());

                                // If current day is before birth day, subtract one month
                                if (today.getDate() < birthDate.getDate()) {
                                    months--;
                                }

                                return Math.max(months, 0);
                            }

                            const postdata = {
                                age: ageInMonths
                            };

                            // console.log('---------postdata------',postdata);

                            const url = global.api_ci_url + "api/fetchfromCI/getGrowthContent";

                            service.postServiceCall(url, postdata)
                                .then((json) => {
                                    console.log("Growth Content:", json);

                                    if (json.msg === 1 && json.result?.articles) {
                                        this.setState({
                                            articles_growth: json.result.articles
                                        });
                                    }
                                })
                                .catch((error) => {
                                    console.error("Error fetching growth content:", error);
                                });
                        
                    }
                );

                // this.state.activeTab == "wt"
                document.querySelector(".select_child_popup.addAns-overlay").style.display="none";

                let url2 = global.api_ci_url + "api/fetchfromCI/getchartgrowthdetails"; 
                let postdata2 = {
                    "chid": data.ChildId,
                    "dob": data.DOB,
                    "gender": data.Gender?.toLowerCase() == "boy" ? "0" : "1",
                }

                return service.postServiceCall(url2, postdata2)
                .then((res2) => {
                    this.setState({
                        pastMeasurement: res2.result.recent_measurement_new,
                    });
                });

            }
        })
        .catch((error) => {
            console.error("Error toggling like:", error);
            service.hideLoader();
        });
    }

    showgrowthdetails=(key)=>{
        this.setState({ activeTab: key });
    }

    capitalizeFirstLetter = (str) => {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    openAddGrowthDetails =()=>{
        this.setState({ showAddGrowthModal: true });
        if(this.state.isApp){
            document.querySelector("body").style.overflow = "hidden";
        }
        

        console.log('------------selectedChildGrowthDetails', this.state.selectedChildGrowthDetails);
        if(this.state.isApp){

            console.log('------------selectedChildGrowthDetails', this.state.selectedChildGrowthDetails);

            let tab_selected = this.state.activeTab;
            let who_range = '';
            if(tab_selected == 'wt'){
                tab_selected = 'Weight';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminwt || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxwt || 0}`;
            }else if(tab_selected == 'ht'){
                tab_selected = 'Height';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminht || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxht || 0}`;
            }else if(tab_selected == 'hc'){
                tab_selected = 'Head Circ.';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminhc || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxhc || 0}`;
            }

            actions.loadCallbackFile();
            const eventName = "vg_add_growth_details_community";
            const eventData = {
                "action_type":'add growth details clicked',
                "date": this.state.selectedChildGrowthDetails.date || '',
                'tab_Selected':tab_selected || '',
                'who_range':who_range || '',
                'weight':Number(this.state.selectedChildGrowthDetails.wt) || '',
                'height':Number(this.state.selectedChildGrowthDetails.ht) || '',
                'head_circumference':Number(this.state.selectedChildGrowthDetails.hc) || '',
                'page_url':window.location.href,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }
    }

    addGrowthDetails = (data) => {

        let dt = Math.floor(new Date(data.date).getTime() / 1000);

        let height = data.heightUnit;
        let headCir = data.hcUnit;
        let heightunit ="cm";
        let headCirunit = "cm";
        let ht = data.height;
        let hc = data.hc;
        
        if(height == "in"){
            height = 1;
            heightunit = "inc"
            ht = parseFloat(ht) / 0.39370;
            ht = parseFloat(ht).toFixed(3);
        }else{
            height = 0;
            heightunit = "cm"
            ht = ht
        }

        if(headCir == "in"){
            headCir = 1;
            headCirunit = "inc";
            hc = parseFloat(hc) / 0.39370;
            hc = parseFloat(hc).toFixed(3);
        }else{
            headCir = 0;
            headCirunit = "cm";
            hc = hc;
        }   

        
        if(this.state.isApp){
            let tab_selected = this.state.activeTab;
            let who_range = '';
            if(tab_selected == 'wt'){
                tab_selected = 'Weight';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminwt || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxwt || 0}`;
            }else if(tab_selected == 'ht'){
                tab_selected = 'Height';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminht || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxht || 0}`;
            }else if(tab_selected == 'hc'){
                tab_selected = 'Head Circ.';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminhc || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxhc || 0}`;
            }
            actions.loadCallbackFile();
            const eventName = "vg_add_growth_details_community";
            const eventData = {
                "action_type":'saved',
                "date": data.date,
                'tab_Selected':tab_selected,
                'who_range':who_range,
                'weight':data.weight,
                'height':ht,
                'head_circumference':hc,
                'page_url':window.location.href,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

        let postdata ={
            "chid":this.state.selectedChild?.ChildId,
            "stid":0,
            "wt":data.weight,
            "ht":ht,
            "hc":hc,
            "htut" :height,
            "heghtM" :heightunit,
            "headM" :headCirunit,
            "hcut" :headCir,
            "dt" :dt,
            "dob" :this.state.selectedChild?.DOB,
            "user_agent" :navigator.userAgent,
            "is_user_desk" :this.state.isDesktop,
            "childname" :this.state.selectedChild?.ChildName,
            "childAge" :this.state.selectedChild?.Age,
            "sourceid" :Math.random().toString(36),
            "deviceToken" :Math.random().toString(36),
            "advertisingID" :Math.random().toString(36)
        }

        // console.log('-------------postdata-11111111111', postdata);

        let url = global.api_ci_url + "api/fetchfromCI/addGrowthDetailsv1"; 

        service.postServiceCall(url, postdata)

        .then((json) => {

            if (json.msg == 1) {

                let url = global.api_ci_url + "api/fetchfromCI/vaccinationSummary";

                let postdata = {
                    summaryfilterType: 0,
                    childinfo: [
                        {
                            childid: this.state.selectedChild.ChildId,
                            dob: this.state.selectedChild.DOB,
                            childgender: this.state.selectedChild.Gender === "Boy" ? "0" : "1"
                        }
                    ]
                };

                
                service.postServiceCall(url, postdata)
                .then((summaryJson) => {

                    const childSummary = summaryJson?.vaccinationSummary?.find(
                        item => item.childId == this.state.selectedChild.ChildId
                    );

                    if (!childSummary?.growthdetails) return;

                    const updatedVaccinationSummary = this.state.vaccinationSummary.map(item => {

                        if (item.childId == this.state.selectedChild.ChildId) {
                            return {
                                ...item,
                                growthdetails: childSummary.growthdetails
                            };
                        }

                        return item;
                    });

                    this.setState({
                        vaccinationSummary: updatedVaccinationSummary,
                        selectedChildGrowthDetails: childSummary.growthdetails,
                        showAddGrowthModal: false
                    });


                     // Refresh Past Measurement
                    const chartUrl = global.api_ci_url + "api/fetchfromCI/getchartgrowthdetails";

                    const chartPostData = {
                        chid: this.state.selectedChild.ChildId,
                        dob: this.state.selectedChild.DOB,
                        gender: this.state.selectedChild.Gender.toLowerCase() === "boy" ? "0" : "1"
                    };

                    service.postServiceCall(chartUrl, chartPostData)
                    .then((res) => {
                        this.setState({
                            pastMeasurement: res.result.recent_measurement_new
                        });
                    })
                    .catch(err => {
                        console.log("getchartgrowthdetails error", err);
                    });



                })


                .catch(error => {
                    console.log('vaccinationSummary error', error);
                });
            }

            document.querySelector("body").style.overflow = "unset";
        })

        .catch((error) => {
            console.error("Error toggling like:", error);
            service.hideLoader();
        });

        
        this.setState ({
            showAddGrowthModal: false
        });
         document.querySelector("body").style.overflow = "unset";
    };


    closeAddGrowthModal = () => {

        if(this.state.isApp){

            let tab_selected = this.state.activeTab;
            let who_range = '';
            if(tab_selected == 'wt'){
                tab_selected = 'Weight';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminwt || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxwt || 0}`;
            }else if(tab_selected == 'ht'){
                tab_selected = 'Height';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminht || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxht || 0}`;
            }else if(tab_selected == 'hc'){
                tab_selected = 'Head Circ.';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminhc || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxhc || 0}`;
            }

            actions.loadCallbackFile();
            const eventName = "vg_add_growth_details_community";
            const eventData = {
                "action_type":'cancelled',
                "date": this.state.selectedChildGrowthDetails.date || '',
                'tab_Selected':tab_selected || '',
                'who_range':who_range || '',
                'weight':Number(this.state.selectedChildGrowthDetails.wt) || '',
                'height':Number(this.state.selectedChildGrowthDetails.ht) || '',
                'head_circumference':Number(this.state.selectedChildGrowthDetails.hc) || '',
                'page_url':window.location.href,
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

        document.querySelector("body").style.overflow = "unset";
        const childList = this.state.childlist || [];

        // const youngestChild = this.state.childlist.find(child => child.ChildSeq === 1);
        const youngestChild = this.state.childlist?.find(child => Number(child.ChildSeq) === 1) || this.state.childlist?.[0] || null;

        // No growth data for currently selected child
        if (!this.state.selectedChildGrowthDetails?.wt) {

            // Youngest child selected → go to first page
            if (youngestChild && youngestChild.ChildId === this.state.selectedChild?.ChildId) {
                this.setState({ gotoFirstpage: true });
                return;
            }

            // Older child selected → switch to youngest child
            if (youngestChild) { 
                this.getLatestChildData(youngestChild);
                this.setState({ showAddGrowthModal: false });
                return;
            }
        }

        this.setState({
            showAddGrowthModal: false
        });
    };

    renderHeightScale = () => {
        const rows = [];

        const unit = "cm";

        // child height in cm from API/state
        const htCm = Number(this.state.selectedChildGrowthDetails?.ht || 0);

        // convert to inch if needed
      
        const rawHt = unit === "inch"
            ? Math.round(htCm / 2.54)
            : htCm;
        const height = Number(rawHt);

        // scale range
        const start = unit === "inch" ? 20 : 50;
        const end = unit === "inch" ? 80 : 105;

        // keep indicator within scale range
        const ht = Math.max(start, Math.min(rawHt, end));
        const indicatorPosition = Math.round(ht);
        // const indicatorPosition = Math.floor(ht);

        for (let i = start; i <= end; i++) {

            let tickClass = "tick small";
            let label = "";

            if (unit === "cm") {
                if (i % 10 === 0) {
                    tickClass = "tick large";
                    label = i;
                } else if (i % 5 === 0) {
                    tickClass = "tick medium";
                    label = i;
                }
            } else {
                // inch scale
                if (i % 5 === 0) {
                    tickClass = "tick large";
                    label = i;
                } else {
                    tickClass = "tick medium";
                }
            }

            rows.push(
                <div className="scale-row" key={i}>
                    {(i === indicatorPosition) && (
                        <div className={`childHeightIndicator ${rawHt > 120 ?'heightTop':'' } ${Number(rawHt) % 1 !== 0 ? 'decimalht' : ''}`}>
                            <div className={`indicator_childName ${this.state.selectedChild?.ChildName?.length > 8?'longName':'' }`}>
                                {this.capitalizeFirstLetter(
                                    this.state.selectedChild?.ChildName
                                )}
                            </div>

                            <div className={`indicator_box`}>
                                <img className="natch_img_height" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/natch_Path20919.svg"></img>
                                <span className="indicator_hight M14_FF"> 
                                    {/* {rawHt.toFixed(1)} {unit}  */}
                                    {Number.isInteger(height) ? height : height.toFixed(1)} {unit}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="scale-label">{label}</div>
                    <div className={tickClass}></div>
                </div>
            );
        }

        return rows;
    };


    openPicker = () => {
        const input = this.dateRef.current;
        if (!input) return;
        if (typeof input.showPicker === "function") {
            input.showPicker();
        } else {
            input.focus();
        }
    };

    openGrowthChart=()=>{
        this.setState({showGrowthChartModal: true });
        if(this.state.isApp){
            document.querySelector("body").style.overflow = "hidden";
        }
        

        if(this.state.isApp){
            let tab_selected = this.state.activeTab;
            let who_range = '';
            if(tab_selected == 'wt'){
                tab_selected = 'Weight';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminwt || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxwt || 0}`;
            }else if(tab_selected == 'ht'){
                tab_selected = 'Height';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminht || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxht || 0}`;
            }else if(tab_selected == 'hc'){
                tab_selected = 'Head Circ.';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminhc || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxhc || 0}`;
            }

            actions.loadCallbackFile();
            const eventName = "vg_add_growth_details_community";
            const eventData = {
                "action_type":'who_chart_click',
                "date": this.state.selectedChildGrowthDetails.date || '',
                'tab_Selected':tab_selected || '',
                'who_range':who_range || '',
                'weight':Number(this.state.selectedChildGrowthDetails.wt) || '',
                'height':Number(this.state.selectedChildGrowthDetails.ht) || '',
                'head_circumference':Number(this.state.selectedChildGrowthDetails.hc) || '',
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

    }
    closeChart=()=>{
        this.setState({showGrowthChartModal: false });
        document.querySelector("body").style.overflow = "unset";
    }

    openAskquestion=()=>{
        this.setState({showAskQueModal: true});
        if(!this.state.isDesktop){
            document.querySelector("body").style.overflow = "hidden";
        }
        

        if(this.state.isApp){
            let tab_selected = this.state.activeTab;
            let who_range = '';
            if(tab_selected == 'wt'){
                tab_selected = 'Weight';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminwt || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxwt || 0}`;
            }else if(tab_selected == 'ht'){
                tab_selected = 'Height';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminht || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxht || 0}`;
            }else if(tab_selected == 'hc'){
                tab_selected = 'Head Circ.';
                who_range = `${this.state.selectedChildGrowthDetails?.idealminhc || 0} - ${this.state.selectedChildGrowthDetails?.idealmaxhc || 0}`;
            }

            actions.loadCallbackFile();
            const eventName = "vg_add_growth_details_community";
            const eventData = {
                "action_type":'ask_a_question',
                "date": this.state.selectedChildGrowthDetails.date || '',
                'tab_Selected':tab_selected || '',
                'who_range':who_range || '',
                'weight':Number(this.state.selectedChildGrowthDetails.wt) || '',
                'height':Number(this.state.selectedChildGrowthDetails.ht) || '',
                'head_circumference':Number(this.state.selectedChildGrowthDetails.hc) || '',
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }
    }

    closeAskquestion =()=>{
        this.setState({showAskQueModal: false});
        document.querySelector("body").style.overflow = "unset";
    }

    closeChildList=()=>{
        document.querySelector(".select_child_popup").style.display="none";
        document.querySelector("body").style.overflow = "unset";
    }

    // goBack = () => {
    //     window.history.back();
    // }
    goBack = () => {
        const isApp = window.location.href.includes("from=app");
        if (!isApp) {
            window.history.back();
            return;
        }
        const currentUrl = window.location.href;
        window.history.back();
        setTimeout(() => {
            // Still on same page => history back did not navigate
            if (window.location.href === currentUrl) {
                const deepjson = {
                    appurl: [
                        {
                            pagetype: "onBackPressed",
                            isFinishWindow: true
                        }
                    ]
                };
                service.jsontracker(JSON.stringify(deepjson));
            }
        }, 500);
    };



    openFaq=()=>{
        const faq_data = document.querySelector(".showFaq-overlay-growth");

        if (faq_data) {
            faq_data.style.display = "block";
        }

        document.documentElement.style.overflow = "hidden";
    }
    closefaqPopup =()=>{
        const faq_data = document.querySelector(".showFaq-overlay-growth");

        if (faq_data) {
            faq_data.style.display = "none";
        }
        document.documentElement.style.overflow = "";
    }

    openDisclaimer=()=>{
        if(!this.state.isDesktop){
            document.querySelector("body").style.overflow = "hidden";
        }
        // this.setState({
        //     showDisclaimerPopup: true,
        // })
        const disclaimer = document.querySelector(".showDisc-overlay");

        if (disclaimer) {
            disclaimer.style.display = "block";
        }

    }

    openFeedback=()=>{
        document.querySelector("body").style.overflow = "hidden";
        this.setState({
            showFeedbackPopup: true,
        })
        // window.location.href = "/tools/baby-growth-tracker-chart/feedback/";
    }

    closeFeedback=()=>{
        document.querySelector("body").style.overflow = "unset";
        this.setState({
            showFeedbackPopup: false,
        })
    }
        
    closeDisclaimer=()=>{
        document.querySelector("body").style.overflow = "unset";
        // this.setState({
        //     showDisclaimerPopup: false,
        // })
        const disclaimer = document.querySelector(".showDisc-overlay");

        if (disclaimer) {
            disclaimer.style.display = "none";
        }
    }
    
    growthArticleEvent = (articleURL, e, title, id) => {

        if (this.state.isApp) {
            actions.loadCallbackFile();
            const eventName = "vg_article_video_community";
            const eventData = {
                action_type: 'article_growth',
                page_type: 'growth',
                article_name: title,
                article_id: id,
                video_name: '',
                video_id: '',
                sendWithoutGtm: "yes"
            };
            service.createfinalTrackingObject(eventName, eventData);

            let appMXPJson = {
                "appurl": [
                    {
                        "pagetype": "communitywebview",
                        "feed":"true",
                        "communityWebViewUrl": articleURL + '?from=app',
                        "communityWebViewTitle": title,
                        "requestURL": articleURL + '?from=app'
                    }
                ]

            }
            // service.jsontracker(JSON.stringify(appMXPJson));
            setTimeout(() => {
                service.jsontracker(JSON.stringify(appMXPJson));
            }, 500); // Adjust the time (in milliseconds) as needed
        }else{
            e.currentTarget.href = `${articleURL}`;
        }

    };

    growthBannerEvent=(e)=>{

        let url = new URL(window.location.href); // Get the current URL
        let params = new URLSearchParams(url.search); // Get the search parameters
        // Get the value of the ref2 parameter
        let ref2Value = params.get('ref2') || ""; 

        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "vg_banner_click";
            const eventData = {
                "component_type": 'Growth banner',
                "image_url": e.target.src,
                "page_type": "growth",
                "ref2":ref2Value,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

    }

    getGrowthData = () => {
        // const { selectedChildGrowthDetails, selectedChild } = this.state;

        let wt = Number(this.state.selectedChildGrowthDetails?.wt || 0);
        let ht = Number(this.state.selectedChildGrowthDetails?.ht || 0);
        let hc = Number(this.state.selectedChildGrowthDetails?.hc || 0);

        const formattedWT = Number.isInteger(wt) ? wt : wt.toFixed(1);
        const formattedHC = Number.isInteger(hc) ? hc : hc.toFixed(1);

        let idealminwt = Number(this.state.selectedChildGrowthDetails?.idealminwt || 0);
        let idealmaxwt = Number(this.state.selectedChildGrowthDetails?.idealmaxwt || 0);

        let idealminht = Number(this.state.selectedChildGrowthDetails?.idealminht || 0);
        let idealmaxht = Number(this.state.selectedChildGrowthDetails?.idealmaxht || 0);

        let idealminhc = Number(this.state.selectedChildGrowthDetails?.idealminhc || 0);
        let idealmaxhc = Number(this.state.selectedChildGrowthDetails?.idealmaxhc || 0);

        // let minwt = Math.max(0, idealminwt - 2);
        // let maxwt = idealmaxwt + 2;
        let minwt = Math.max(0, idealminwt - 2).toFixed(2);
        let maxwt = (idealmaxwt + 2).toFixed(2);

        let minhc = Math.max(0, idealminhc - 2);
        let maxhc = idealmaxhc + 2;

        let isBoy = this.state.selectedChild?.Gender?.toLowerCase() === "boy";

        let whotext = "";
        let whoheighttext = "";
        let whohctext = "";
        let showAskQueWeight ="False";
        let showAskQueHeight ="False";
        let showAskQueHeadCir ="False";

        // ✅ Weight %
        let percentage = 0;
        let x_width = 0;

        if (wt <= idealminwt) {
            percentage = ((wt - minwt) / (idealminwt - minwt)) * 33;
            whotext = `and ${isBoy ? "his" : "her"} weight is lower as per WHO standard`;
            showAskQueWeight = "True";

        } else if (wt <= idealmaxwt) {
            percentage = 33 + ((wt - idealminwt) / (idealmaxwt - idealminwt)) * 33;
            whotext = `and ${isBoy ? "his" : "her"} weight is in the range of WHO standard`;
            showAskQueWeight = "False";
        } else {
            percentage = 66 + ((wt - idealmaxwt) / (maxwt - idealmaxwt)) * 34;
            whotext = `and ${isBoy ? "his" : "her"} weight is higher as per WHO standard`;
            showAskQueWeight = "True";
        }

        percentage = Math.max(0, Math.min(percentage, 100));
        const isRightSide = percentage > 70;

        // const barWidth = 314; // actual width
        // x_width = (percentage / 100) * barWidth;



        // ✅ Height text
        if (ht <= idealminht) {
            whoheighttext = `and ${isBoy ? "his" : "her"} height is below the WHO Standards`;
            showAskQueHeight = "True";
        } else if (ht <= idealmaxht) {
            whoheighttext = `and ${isBoy ? "his" : "her"} height is in the range of WHO Standards`;
            showAskQueHeight = "False";
        } else {
            whoheighttext = `and ${isBoy ? "his" : "her"} height is above the WHO Standards`;
            showAskQueHeight = "True";
        }

        // ✅ Head Circumference %
        let hc_percent = 0;

        if (hc <= idealminhc) {
            hc_percent = ((hc - minhc) / (idealminhc - minhc)) * 33;
            whohctext = `and ${isBoy ? "his" : "her"} head circumference is lower as per WHO Standards`;
            showAskQueHeadCir = "True";
        } else if (hc <= idealmaxhc) {
            hc_percent = 33 + ((hc - idealminhc) / (idealmaxhc - idealminhc)) * 33;
            whohctext = `and ${isBoy ? "his" : "her"} head circumference is in the range of WHO Standards`;
            showAskQueHeadCir = "False";
        } else {
            hc_percent = 66 + ((hc - idealmaxhc) / (maxhc - idealmaxhc)) * 34;
            whohctext = `and ${isBoy ? "his" : "her"} head circumference is higher as per WHO Standards`;
            showAskQueHeadCir = "True";
        }

        hc_percent = Math.max(0, Math.min(hc_percent, 100));
        const isRightSidehc = hc_percent > 70;

        return {
            wt,
            ht,
            hc,
            formattedWT,
            formattedHC,
            percentage,
            x_width,
            hc_percent,
            whotext,
            whoheighttext,
            whohctext,
            isRightSide,
            isRightSidehc,
            minwt,
            maxwt,
            minhc,
            maxhc,
            idealminwt,
            idealmaxwt,
            idealminht,
            idealmaxht,
            idealminhc,
            idealmaxhc,
            showAskQueWeight,
            showAskQueHeight,
            showAskQueHeadCir,
        };
    };

  
  render() {

     const {
            wt,
            ht,
            hc,
            formattedWT,
            formattedHC,
            percentage,
            x_width,
            hc_percent,
            whotext,
            whoheighttext,
            whohctext,
            isRightSide,
            isRightSidehc,
            minwt,
            maxwt,
            minhc,
            maxhc,
            idealminwt,
            idealmaxwt,
            idealminht,
            idealmaxht,
            idealminhc,
            idealmaxhc,
            showAskQueWeight,
            showAskQueHeight,
            showAskQueHeadCir,
    } = this.getGrowthData();
  
    const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";



    const params_growth = {
        observer: true,
        observeParents: true,
        rebuildOnUpdate: true,
        centeredSlides: false,
        slidesOffsetAfter: 16,
        loop: false,
        initialSlide: 0,
        breakpoints: {
            320: {
                slidesPerView: 1.18,
                spaceBetween: 12,
            },

            369: {
                slidesPerView: 1.35,
                spaceBetween: 16,
            },

            420: {
                slidesPerView: 1.45,
                spaceBetween: 16,
            },

            768: {
                slidesPerView: 3.1,
                spaceBetween: 16,
            },

            1024: {
                slidesPerView: 4.4,
                spaceBetween: 25,
            }
            
        }
    };


    // console.log('____________>>>>>>>>',this.state.selectedChildGrowthDetails?.wt);
    // console.log('____________>>>>>>>>',typeof this.state.selectedChildGrowthDetails?.wt);

    return (
        <main className="maincontainer1" style={{ height: this.state.activeTab == "ht" ? "auto" : "auto" }} >
            <div className="outercontainerGrowth" >
                <div id={`${this.state.isLoggedin}`}
                    className={
                        this.state.isLoggedin==true
                        ? 'outerContainer'
                        : 'outerContainer_nonlog'
                    } 
                    >
                    <div className="main-container">
                        <Helmet>
                            <title>Child Growth Tracker - Baby Height, Weight & Growth Chart (India) – FirstCry Parenting</title>
                            <meta name="description" content="Track your baby’s height, weight, and overall development with our free child growth tracker. Compare child growth with monitor progress from newborn to kids all ages." />
                            <meta name="keywords" content="immunization schedule, immunization calendar, vaccination schedule"/>
                            <link rel="canonical" href="https://parenting.firstcry.com/tools/baby-growth-tracker-chart/" />
                        </Helmet>
                        

                        {(!this.state.isLoggedin || this.state.childlist.length < 1 || this.state.gotoFirstpage) ? (
                        <>
                            {this.state.isDesktop && ( 
                                <div className="titlegrowthTracker 1">
                                    <>
                                    <div className="breadcrumbvcc">
                                        <span><a href={service.getRedirectUrl("/")} className="">Home</a></span>
                                        <span className="breadcrum_icon" data-icon-font="l"></span>
                                        <span><a href={service.getRedirectUrl("/tools/")} className="">Tools</a></span>
                                        <span className="breadcrum_icon" data-icon-font="l"></span>
                                        <span>Child Growth Tracker</span>
                                    </div>
                                    <hr className="titlehr"></hr>
                                    </>
                                </div>
                            )}
                            <Nonloggedin  eleRef={this} type={"growth"}/>
                        </>
                        ): (
                        <>
                            
                            <div className="titlegrowthTracker 2">
                                {this.state.isDesktop && ( 
                                    <div className="breadcrumbvcc">
                                        <span><a href={service.getRedirectUrl("/")} className="">Home</a></span>
                                        <span className="breadcrum_icon" data-icon-font="l"></span>
                                        <span><a href={service.getRedirectUrl("/tools/")} className="">Tools</a></span>
                                        <span className="breadcrum_icon" data-icon-font="l"></span>
                                        <span>Child Growth Tracker</span>
                                    </div>
                                )}
                                <div className="title_filter">
                                    {this.state.isDesktop ? ( 
                                            <h1 className="R28_21" id="skipToH1" aria-label="Child Growth Tracker">Child Growth Tracker</h1>
                                        ):(
                                    <h1 className="mob_Vcc_Title" aria-label="Child Growth Tracker">
                                        <img className="mob_back_arrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png" onClick={()=>this.goBack()} alt="back img"></img>
                                        {capitalize(this.state.selectedChild?.ChildName)}'s Growth Tracker
                                    </h1>
                                    )}
                                </div>
                            </div>

                            <hr className="titlehr"></hr>
                            <div className="questionLeft_outer questionLeft">
                                <div className="questionLeft_1">
                                    <div className="loggedin_div">
                                        <div className="nonlog_slider_wrapper nonlog_slider_wrapper_growth">        
                                            <div className={` ${this.state.isDesktop ? "banner_card" :"mob_banner_card"} `}>
                                                {this.state.isDesktop ? ( 
                                                    <img src={this.state.banner_img_desk} alt="Child Growth Tracker" title="Child Growth Tracker" className="GTMTopBanner" data-page="growth"/>
                                                ):(
                                                    <img  src={this.state.banner_img_mob} alt="Child Growth Tracker" title="Child Growth Tracker" onClick={this.growthBannerEvent}
                                                    className="GTMTopBanner" data-page="growth"/>
                                                )}
                                            </div>


                                            {/* <div className={`${this.state.isDesktop ? "banner_card" : "mob_banner_card"} `}>
                                                <div className="customBannerCarousel">
                                                    <div className="bannerSliderTrack" style={{ transform: `translateX(-${this.state.activeBannerIndex * 100}%)`}}>
                                                        {this.state.bannerList.map((banner, index) => (
                                                            <div className="bannerSlide" key={index}>
                                                                <img
                                                                    src={this.state.isDesktop ? banner.desk : banner.mob}
                                                                    alt="Child Growth Tracker"
                                                                    title="Child Growth Tracker"
                                                                    className="GTMTopBanner"
                                                                    data-page="growth"
                                                                    onClick={this.state.isDesktop ? undefined : this.growthBannerEvent}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>

                                                    // Dots
                                                    {this.state.bannerList.length > 1 && (
                                                        <div className="bannerDots">
                                                            {this.state.bannerList.map((_, index) => (
                                                                <span
                                                                    key={index}
                                                                    className={`bannerDot ${
                                                                        this.state.activeBannerIndex === index ? "active" : ""
                                                                    }`}
                                                                    onClick={() =>
                                                                        this.setState({
                                                                            activeBannerIndex: index
                                                                        })
                                                                    }
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div> */}


                                        </div>
                                        
                                        <div className="growth_details_div">
                                            {/* Child select start */}
                                            <div className="vcc_dropdown_sec_wrap growth_tr_child_select">
                                                <div className="vcc_dropdown_head" onClick={()=>this.openprofilePopup()}>
                                                    <div className="vcc_select_child M20_21">
                                                        <div className="vcc_dropdown_row">
                                                            <div className="profile_name_img">
                                                                <div className="vcc_arti_circle_img sel_profile">
                                                                <img 
                                                                    src={
                                                                        this.state.selectedChild?.childPhoto
                                                                        ? this.state.selectedChild.childPhoto
                                                                        : this.state.selectedChild?.Gender?.toLowerCase() == "boy"
                                                                            ? "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_boy_community.png"
                                                                            : "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_girl_community.jpg"
                                                                        }

                                                                    alt="userprofile pic" />
                                                                </div>
                                                                <div className="gr_tr_select_child">
                                                                    <span className="gr_tr_child_name M18_21">{capitalize(this.state.selectedChild?.ChildName) || ""}</span>
                                                                    <span className="gr_tr_childage R14_42">{this.state.selectedChild?.Age} old {this.state.selectedChild?.Gender} </span>
                                                                </div>
                                                            </div>
                                                            <div className="vcc_sel_down_arrow">
                                                                <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Arrowchild_select.svg" alt="dropdown arrow" ></img>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Child Select End */}

                                            <div className="growthMetricTab">
                                                <div className={`growthMetricWeight ${this.state.activeTab == "wt" ? "active_tab" : ""}`}
                                                    onClick={() => this.showgrowthdetails("wt")}
                                                >
                                                    <div className="growthDetails"> 
                                                        <span className={`${this.state.activeTab == "wt" ? "M15_FF" : "R15_75"} `}>WEIGHT</span>
                                                        <div className={`${this.state.activeTab == "wt" ? "growthDetails_hract" : "growthDetails_hr"} `} ></div>
                                                        <span className={`${this.state.activeTab == "wt" ? "M20_FF" : "M20_42"}`}>
                                                            {!isNaN(Number(this.state.selectedChildGrowthDetails?.wt))
                                                                ? `${
                                                                    Number(this.state.selectedChildGrowthDetails?.wt) % 1 === 0
                                                                        ? Number(this.state.selectedChildGrowthDetails?.wt)
                                                                        : Number(this.state.selectedChildGrowthDetails?.wt).toFixed(1)
                                                                } kg` : "0 kg"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className={`growthMetricHeight ${this.state.activeTab == "ht" ? "active_tab" : ""}`}
                                                    onClick={() => this.showgrowthdetails("ht")}
                                                >
                                                    <div className="growthDetails"> 
                                                        <span className={`${this.state.activeTab == "ht" ? "M15_FF" : "R15_75"} `}>HEIGHT</span>
                                                        <div className={`${this.state.activeTab == "ht" ? "growthDetails_hract" : "growthDetails_hr"} `} ></div>
                                                        <span className={`${this.state.activeTab == "ht" ? "M20_FF" : "M20_42"}`}>

                                                            {!isNaN(Number(this.state.selectedChildGrowthDetails?.ht))
                                                                ? `${
                                                                    Number(this.state.selectedChildGrowthDetails?.ht) % 1 === 0
                                                                        ? Number(this.state.selectedChildGrowthDetails?.ht)
                                                                        : Number(this.state.selectedChildGrowthDetails?.ht).toFixed(1)
                                                                } cm`
                                                                : "0 cm"
                                                            }
                                                            
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className={`growthMetricHead ${this.state.activeTab == "hc" ? "active_tab" : ""}`}
                                                    onClick={() => this.showgrowthdetails("hc")}
                                                >
                                                    <div className="growthDetails"> 
                                                        <span className= {`${this.state.activeTab == "hc" ? "M15_FF" : "R15_75"} `} >HEAD CRIC.</span>
                                                        <div className={`${this.state.activeTab == "hc" ? "growthDetails_hract" : "growthDetails_hr"} `} ></div>
                                                        <span className={`${this.state.activeTab == "hc" ? "M20_FF" : "M20_42"}`}>
                                                            {/* {!isNaN(parseFloat(this.state.selectedChildGrowthDetails?.hc))
                                                                ? `${parseFloat(this.state.selectedChildGrowthDetails.hc).toFixed(1)} cm`
                                                                : "0 cm"} */}
                                                            {!isNaN(Number(this.state.selectedChildGrowthDetails?.hc))
                                                                ? `${
                                                                    Number(this.state.selectedChildGrowthDetails?.hc) % 1 === 0
                                                                        ? Number(this.state.selectedChildGrowthDetails?.hc)
                                                                        : Number(this.state.selectedChildGrowthDetails?.hc).toFixed(1)
                                                                } cm`
                                                                : "0 cm"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                                    <input type="hidden" id="markdate" value={new Date(this.state.selectedChildGrowthDetails?.date)
                                                                    .toLocaleDateString("en-US", {
                                                                        month: "long",
                                                                        day: "numeric",
                                                                        year: "numeric"
                                                                    })} />
                                                    <input type="hidden" id="weight" value={`${ Number.isInteger(Number(this.state.selectedChildGrowthDetails?.wt))
                                                                            ? Number(this.state.selectedChildGrowthDetails?.wt)
                                                                            : Number(this.state.selectedChildGrowthDetails?.wt).toFixed(1)
                                                                    } kg`}/>
                                                    <input type="hidden" id="height" value={`${ Number.isInteger(Number(this.state.selectedChildGrowthDetails?.ht))
                                                                        ? Number(this.state.selectedChildGrowthDetails?.ht)
                                                                        : Number(this.state.selectedChildGrowthDetails?.ht).toFixed(1)
                                                                    } cm`}/>
                                                    <input type="hidden" id="headCircle" value={`${formattedHC} cm`}/>

                                            {this.state.activeTab == "wt" &&
                                                <>
                                            
                                                <div className="childGrowthChart">
                                                    <div className="growthchart_head">
                                                        <span className="headingchart R16_42M">Your Child's Growth Chart</span>
                                                        <span className="chartbtn" onClick={this.openGrowthChart} >WHO CHART</span>
                                                    </div>
                                                    

                                                    <div className="growthchart_weight_details">
                                                        <div className="lastUpdated">
                                                            <span className="lastUpdated_text">
                                                                Last updated on: <span className="updated_date"> 
                                                                {
                                                                    new Date(this.state.selectedChildGrowthDetails?.date)
                                                                    .toLocaleDateString("en-US", {
                                                                        month: "long",
                                                                        day: "numeric",
                                                                        year: "numeric"
                                                                    })
                                                                } </span> : { Number.isInteger(Number(this.state.selectedChildGrowthDetails?.wt))
                                                                            ? Number(this.state.selectedChildGrowthDetails?.wt)
                                                                            : Number(this.state.selectedChildGrowthDetails?.wt).toFixed(1)
                                                                    } kg
                                                            </span>
                                                        </div>
                                                        <div className="child_detailsdiv">
                                                            <div className="child-profile">
                                                                <div className={`child-profile-img ${isRightSide ? "left-side" : "right-side"}`} style={{ left: `${percentage}%` }}>
                                                                    <div className="profile_img_div">
                                                                        <img 
                                                                            className="child-profile-image"
                                                                            src={
                                                                            this.state.selectedChild?.childPhoto
                                                                            ? this.state.selectedChild.childPhoto
                                                                            : this.state.selectedChild?.Gender?.toLowerCase() == "boy"
                                                                                ? "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_boy_community.png"
                                                                                : "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_girl_community.jpg"
                                                                            }
                                                                        ></img>
                                                                        <img className="downarrow" 
                                                                        src="https://cdn.cdnparenting.com/brainbees/community/vaccination/down_arrow_indicator.svg"></img>
                                                                    </div>
                                                                    <div className={`child-profile-name ${isRightSide ? "left-side" : "right-side"}`}>
                                                                        
                                                                        <div className={`hc_indicatorBox ${ Number(formattedWT) % 1 !== 0 ? 'decimal' : '' }`} >
                                                                            <div className={`hc_indicator_childname ${this.state.selectedChild?.ChildName.length>8?'longNamewt':''} `}>{ this.capitalizeFirstLetter(this.state.selectedChild?.ChildName)}</div>
                                                                            {isRightSide ? (
                                                                                <>
                                                                                    <div className="indicator_grp_right ">
	                                                                                    <img className="natch_img_right" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/natch_Path20919.svg"></img>
                                                                                        <span className="hc_right_indicatortext M14_FF">{formattedWT} kg</span>
                                                                                    </div>
                                                                                </>
                                                                            ):(
                                                                                <>
                                                                                     <div className="indicator_grp">
                                                                                        <img className="natch_img" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/natch_Path20919.svg"></img>
                                                                                        <span className="hc_indicatortext M14_FF">{formattedWT} kg</span>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="weight_bardiv">
                                                            <div className="weight_barRed"></div>
                                                            <div className="weight_barGreen"></div>
                                                            <div className="weight_barRed"></div>
                                                        </div>
                                                        <div className="uparrow_div">
                                                            <div className="weightRange">
                                                                <div className="part1">
                                                                    <span>{!isNaN(minwt) ? minwt : "0"} Kg</span>
                                                                    <span>{!isNaN(idealminwt) ? idealminwt : "0"} Kg</span>
                                                                </div>
                                                                <div className="part2">
                                                                    <span>{!isNaN(idealmaxwt) ? idealmaxwt : "0"} Kg</span>
                                                                    <span>{!isNaN(maxwt) ? maxwt : "0"} Kg</span>
                                                                </div>

                                                            </div>
                                                            {this.state.isDesktop ? (
                                                                <img className="uparrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/uparrow.png" alt="uparrow"></img>
                                                            ):(
                                                                <img className="uparrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/down_arrow_indicator.svg" alt="uparrow"></img>
                                                            )}
                                                            
                                                        </div>
                                                        <div className="idelRange">
                                                            <span className="range">Ideal Range (WHO)</span>
                                                            <span className="weighteRange">{!isNaN(idealminwt) ? idealminwt : "0"} kg - {!isNaN(idealmaxwt) ? idealmaxwt : "0"} kg</span>
                                                        </div>
                                                        {this.state.isDesktop && 
                                                            <div className="add-Growth-Details-btn weight growth_ds" onClick={this.openAddGrowthDetails} >
                                                                Update Growth Details
                                                            </div>
                                                        }

                                                    </div>
                                                    {!this.state.isDesktop && 
                                                        <div className="add-Growth-Details-btn weight growth_ms" onClick={this.openAddGrowthDetails} >
                                                            Update Growth Details
                                                        </div>
                                                    }
                                                    
                                                </div>

                                                <div className={`ask-a-question-CTA-div ${showAskQueWeight == "True" ? "":"askqueBtnFls"}`}>
                                                    <div className="ask-a-question-CTA-text">
                                                        {capitalize(this.state.selectedChild?.ChildName)} is {this.state.selectedChild?.Age} {whotext}
                                                    </div>
                                                    {(showAskQueWeight == "True") && 
                                                        <div className="ask-a-question-CTA" onClick={this.openAskquestion}>
                                                            Ask A Question
                                                        </div>
                                                    }
                                                </div>

                                                {this.state.pastMeasurement?.recent_wt?.length > 0 && 
                                                    <PastMeasurement data={this.state.pastMeasurement.recent_wt} type="wt" />
                                                }

                                                </>
                                            }

                                            {this.state.activeTab == "ht" &&
                                                <>
                                                <div className="childGrowthChartheight">
                                                    <div className="growthchart_head">
                                                        <span className="headingchart R16_42M">Your Child's Growth Chart</span>
                                                        <span className="chartbtn" onClick={this.openGrowthChart}  >WHO CHART</span>
                                                    </div>
                                                    <div className="growthchart_height_details">
                                                        <div className="lastUpdated">
                                                            <span className="lastUpdated_text">
                                                                Last updated on: <span className="updated_date">  {
                                                                    new Date(this.state.selectedChildGrowthDetails?.date)
                                                                    .toLocaleDateString("en-US", {
                                                                        month: "long",
                                                                        day: "numeric",
                                                                        year: "numeric"
                                                                    })
                                                                } </span> : { Number.isInteger(Number(this.state.selectedChildGrowthDetails?.ht))
                                                                        ? Number(this.state.selectedChildGrowthDetails?.ht)
                                                                        : Number(this.state.selectedChildGrowthDetails?.ht).toFixed(1)
                                                                    } cm
                                                            </span>
                                                        </div>
                                                        <div className="child_detailsdiv_height">
                                                            <div className="scale-container">
                                                                <div className="height-scale">
                                                                    {this.renderHeightScale()}
                                                                </div>
                                                                <div className="hight_left_box">
                                                                    <div className="idealHeightRange">
                                                                        <span className="R13_61">Ideal Range (WHO)</span>
                                                                        <span className="weighteRange">{!isNaN(idealminht) ? idealminht : "0"} - {!isNaN(idealmaxht) ? idealmaxht : "0"} cm</span>
                                                                    </div>
                                                                    <div className="child_img_height">
                                                                        <img className="childHeightImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/baby%20full%20image.png" alt="Child image"></img>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.isDesktop && 
                                                            <div className="add-Growth-Details-btn add-Growth-Details-btn-height" onClick={this.openAddGrowthDetails} >
                                                                Update Growth Details
                                                            </div>
                                                        }
                                                    </div>
                                                    {!this.state.isDesktop && 
                                                        <div className="add-Growth-Details-btn add-Growth-Details-btn-height" onClick={this.openAddGrowthDetails} >
                                                            Update Growth Details
                                                        </div>
                                                    }
                                                </div>

                                                <div className={`ask-a-question-CTA-div ${showAskQueHeight == "True" ? "":"askqueBtnFls"}`}>
                                                    <div className="ask-a-question-CTA-text">
                                                        {capitalize(this.state.selectedChild?.ChildName)} is {this.state.selectedChild?.Age} {whoheighttext}
                                                    </div>
                                                    {(showAskQueHeight == "True") && 
                                                        <div className="ask-a-question-CTA" onClick={this.openAskquestion}>
                                                            Ask A Question
                                                        </div>
                                                    }

                                                </div>

                                                {this.state.pastMeasurement?.recent_ht?.length > 0 && 
                                                    <PastMeasurement data={this.state.pastMeasurement.recent_ht} type="ht" />
                                                }

                                                </>
                                            }

                                            {this.state.activeTab == "hc" &&
                                                <>
                                                <div className="childGrowthChart">
                                                    <div className="growthchart_head">
                                                        <span className="headingchart R16_42M">Your Child's Growth Chart</span>
                                                        <span className="chartbtn" onClick={this.openGrowthChart} >WHO CHART</span>
                                                    </div>

                                                    <div className="growthchart_weight_details">
                                                        <div className="lastUpdated">
                                                            <span className="lastUpdated_text">
                                                                Last updated on: <span className="updated_date"> {
                                                                    new Date(this.state.selectedChildGrowthDetails?.date)
                                                                    .toLocaleDateString("en-US", {
                                                                        month: "long",
                                                                        day: "numeric",
                                                                        year: "numeric"
                                                                    })
                                                                }</span> : {formattedHC} cm
                                                            </span>
                                                        </div>
                                                        <div className="child_detailsdiv">
                                                            <div className="child-profile">
                                                                <div className={`child-profile-img ${isRightSidehc ? "left-side" : "right-side"}`}  style={{ left: `${hc_percent}%` }}>
                                                                    <div className="profile_img_div">
                                                                        <img 
                                                                            className="child-profile-image"
                                                                            src={
                                                                            this.state.selectedChild?.childPhoto
                                                                            ? this.state.selectedChild.childPhoto
                                                                            : this.state.selectedChild?.Gender?.toLowerCase() == "boy"
                                                                                ? "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_boy_community.png"
                                                                                : "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_girl_community.jpg"
                                                                            }
                                                                        ></img>
                                                                        <img className="downarrow" 
                                                                        src="https://cdn.cdnparenting.com/brainbees/community/vaccination/down_arrow_indicator.svg"></img>
                                                                    </div>
                                                                    <div className={`child-profile-name ${isRightSidehc ? "left-side" : "right-side"}`}>
                                                                        
                                                                        <div className={`hc_indicatorBox ${ Number(formattedHC) % 1 !== 0 ? 'decimal' : '' }`} >
                                                                            <div className={`hc_indicator_childname ${this.state.selectedChild?.ChildName.length>8?'longNamewt':''}`}>{ this.capitalizeFirstLetter(this.state.selectedChild?.ChildName)}</div>
                                                                            {isRightSidehc ? (
                                                                                <>
                                                                                    <div className="indicator_grp_right">
                                                                                        {/* <img className="hc_right_indicator" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/indicator.png?v1" alt="Indicator Img"></img> */}
                                                                                        <img className="natch_img_right" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/natch_Path20919.svg"></img>
                                                                                        <span className="hc_right_indicatortext M14_FF">{formattedHC} cm</span>
                                                                                    </div>
                                                                                </>
                                                                            ):(
                                                                                <>
                                                                                    {/* <img className="hc_indicator" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/rightIndicator.png" alt="Indicator Img"></img> */}
                                                                                    <div className="indicator_grp">
                                                                                        <img className="natch_img" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/natch_Path20919.svg"></img>
                                                                                        <span className="hc_indicatortext M14_FF">{formattedHC} cm</span>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <img className="downarrow" 
                                                                src="https://cdn.cdnparenting.com/brainbees/community/vaccination/down_arrow_indicator.svg"></img> */}
                                                            </div>
                                                        </div>
                                                        <div className="weight_bardiv">
                                                            <div className="weight_barRed"></div>
                                                            <div className="weight_barGreen"></div>
                                                            <div className="weight_barRed"></div>
                                                        </div>
                                                        <div className="uparrow_div">
                                                            <div className="weightRange">
                                                                <div className="part1">
                                                                    <span>{!isNaN(minhc) ? minhc : "0"} cm</span>
                                                                    <span>{!isNaN(idealminhc) ? idealminhc : "0"} cm</span>
                                                                </div>
                                                                <div className="part2">
                                                                    <span>{!isNaN(idealmaxhc) ? idealmaxhc : "0"} cm</span>
                                                                    <span>{!isNaN(maxhc) ? maxhc : "0"} cm</span>
                                                                </div>
                                                            </div>
                                                            {this.state.isDesktop ? (
                                                                <img className="uparrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/uparrow.png" alt="uparrow"></img>
                                                            ):(
                                                                <img className="uparrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/down_arrow_indicator.svg" alt="uparrow"></img>
                                                            )}
                                                        </div>
                                                        <div className="idelRange">
                                                            <span className="range">Ideal Range (WHO)</span>
                                                            <span className="weighteRange">{!isNaN(idealminhc) ? idealminhc : "0"} cm - {!isNaN(idealmaxhc) ? idealmaxhc : "0"} cm</span>
                                                        </div>
                                                        {this.state.isDesktop && 
                                                            <div className="add-Growth-Details-btn head 1" onClick={this.openAddGrowthDetails} >
                                                                Update Growth Details
                                                            </div>
                                                        }
                                                    </div>
                                                    {!this.state.isDesktop && 
                                                        <div className="add-Growth-Details-btn head" onClick={this.openAddGrowthDetails} >
                                                            Update Growth Details
                                                        </div>
                                                    }
                                                </div>

                                                <div className={`ask-a-question-CTA-div ${showAskQueHeadCir == "True" ? "":"askqueBtnFls"}`}>
                                                    <div className="ask-a-question-CTA-text">
                                                        {capitalize(this.state.selectedChild?.ChildName)} is {this.state.selectedChild?.Age} {whohctext}
                                                    </div>
                                                    {(showAskQueHeadCir == "True") && 
                                                        <div className="ask-a-question-CTA" onClick={this.openAskquestion}>
                                                            Ask A Question
                                                        </div>
                                                    }

                                                </div>

                                                {this.state.pastMeasurement?.recent_hd_cir?.length > 0 && 
                                                    <PastMeasurement data={this.state.pastMeasurement.recent_hd_cir} type="hc" />
                                                }

                                                </>
                                            }
                                        </div>

                                    </div>
                                </div>
                                {(this.state.isDesktop && !this.state.isApp) &&
                                    <>
                                        <div className="advertisement_wrapper" ref={this.wrapperRef}>
                                            {/* <div className="advertisementRight advertisement_block"> */}
                                             <div ref={this.adRef} className={`advertisementRight advertisement_block ${this.state.adState}`}
                                                    >
                                                <div className=" advertisementRight_growth">
                                                    <div style={{textAlign: "center",padding: "15px 0px 11px",fontSize: "12px",}}>ADVERTISEMENT</div>
                                                    <div className="rightside">
                                                        <div id="c21ba44c-f89a-460f-bbb9-bc29c66647af"
                                                            className="_ap_apex_ad"
                                                            style={{ width: "336px", height: "280px" }}
                                                        >
                                                            {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/912117783681748523%201.png"></img> */}
                                                        </div>
                                                    </div> 
                                                    
                                                </div>


                                                <div className=" advertisementRight_growth">
                                                    <div style={{textAlign: "center",padding: "15px 0px 11px",fontSize: "12px",}}>ADVERTISEMENT</div>
                                                    <div className="rightside">
                                                        <div id="1f428a2d-000a-439a-8305-6d9c86cf257a"
                                                            className="_ap_apex_ad"
                                                            style={{ width: "336px", height: "280px" }}
                                                        >
                                                            {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/912117783681748523%201.png"></img> */}

                                                        </div>
                                                        
                                                    </div> 
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>

                            <ChildListOverlay eleRef={this} />

                            {this.state.showAddGrowthModal && (
                                <AddGrowthDetails eleRef={this} />
                            )}
                            {this.state.showGrowthChartModal && (
                                <GrowthDetailsChart eleRef={this} type={this.state.activeTab}   />
                            )}  

                            {this.state.showAskQueModal && (
                                // <AskqueOverlay eleRef={this} childData={global.userAry['childData']['UserChildList']} />
                                <AskqueOverlay
                                        eleRef={this}
                                        childData={this.state.childlist}
                                    />
                            )}
                                
                        </>
                        )}

                        <div className="alertMsg-overlay">
                            <div className="alert-popup">
                                <span className="alertmsg"></span>
                            </div>
                        </div>

                        
                    </div>

                </div>
                {(this.state.isLoggedin && !this.state.isDesktop && this.state.childlist?.length > 0) &&
                    <div className="curve_mob_img_growth">
                        <img
                            src="https://cdn.cdnparenting.com/brainbees/community/vaccination/curve_img_mob2.png"
                            alt=""
                        />
                    </div>
                }

                {this.state.isLoggedin && this.state.selectedChildGrowthDetails &&
                        typeof this.state.selectedChildGrowthDetails === 'object' &&
                        Object.keys(this.state.selectedChildGrowthDetails).length > 0 && (
                    <div className="RelatedArticles_div_container">
                        <div className="growth_RelatedArticles_div">
                            <div className="growth_RelatedArticles_title">
                            {this.state.isDesktop ? 'Related Articles':'Suggested articles for you'}  
                            </div>
                        
                            <div className="growth_reletedArticles">

                                <div className="growth_article_list">
                                    <Swiper {...params_growth}>
                                        {this.state.articles_growth.map(article => (
                                        <div key={article.id} className="growth_article" > 
                                        {/* onClick={(e) => this.growthArticleEvent(article.article_url,e, article.article_title, article.id)} */}
                                            <a 
                                                onClick={(e) => {
                                                    this.growthArticleEvent(
                                                        article.article_url,
                                                        e,
                                                        article.article_title,
                                                        article.id
                                                    );
                                                }}
                                            target="_blank" rel="noopener noreferrer" >



                                            <div className="growth_article_info" data-artname={article.article_title} data-artid={article.id} >
                                                <div className="growth_article_images">
                                                    <img src={article.article_image} alt={article.article_title} />
                                                </div>

                                                <div className="growth_article_title">
                                                    <span>{article.article_title}</span>
                                                </div>
                                            </div>
                                            </a>
                                        </div>
                                        ))}
                                    </Swiper>
                                </div>

                            </div>
                            {this.state.isDesktop &&
                                // <hr className="growth_relatedArticles_hr"></hr>
                                <div className="growth_relatedArticles_hr" ></div>
                            }
                        </div>
                        
                    </div>
                    )
                }
            </div>
            {(this.state.isDesktop) &&
                <div className="curve_img_growth">
                    <img
                        src="https://cdn.cdnparenting.com/brainbees/community/vaccination/curve_img_desktop.png"
                        alt=""
                    />
                </div>
            }
                <div className={`${(this.state.isLoggedin==true && this.state.childlist?.length > 0) ?'faq_container_growth':'faq_container_growth_nonlog'}`}>
                    <div className="faq_mobdiv">
                        <span className="R14_9e" onClick={()=>this.openFaq()} >FAQs</span>
                        <span className="R14_9e" onClick={()=>this.openDisclaimer()}>Disclaimer</span>
                        <span className="R14_9e" onClick={()=>this.openFeedback()} >Feedback</span>
                    </div>
                </div>
                
                
                {/* {this.state.showFaqPopup && */}
                    <FAQPopupGrowth eleRef={this} />
                {/* } */}

                {/* {this.state.showDisclaimerPopup && */}
                    <DisclaimerPopup eleRef={this} />
                {/* } */}
                {this.state.showFeedbackPopup && 
                    <FeedbackPopup eleRef={this} />
                }
                        
                        
        </main>
        
    )

  }
}
export default withContext(GrowthTracker);